// using https://www.regular-expressions.info/email.html as reference
// modified a bit to support our needs.
export const validateEmail = (email: string): boolean => {
    if (email?.length) {
        return email.length <= 254 &&
        new RegExp(/^[A-Z0-9][A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]{2,}$/i).test(email);
    }

    return false;
};